// Application-wide settings and configuration values
export const settings = {
  // Contact Information
  phone: {
    support: '(855) 303-1455',
    supportRaw: '8553031455'
  },
  
  // Business Hours (in PST/PDT)
  businessHours: {
    weekday: {
      start: 5, // 5 AM
      end: 19   // 7 PM
    },
    saturday: {
      start: 8, // 8 AM
      end: 17   // 5 PM
    },
    sunday: {
      start: 8, // 8 AM
      end: 17   // 5 PM
    }
  }
} as const;